import { render, staticRenderFns } from "./MemberListQuitLayout.vue?vue&type=template&id=38459e24&scoped=true&"
import script from "./MemberListQuitLayout.vue?vue&type=script&lang=js&"
export * from "./MemberListQuitLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38459e24",
  null
  
)

export default component.exports